<template>
  <div
    v-if="locationImg"
    class="operate-location"
  >
    <div
      class="operate-location__image"
      :style="{ backgroundImage: `url(${locationImg})` }"
      :class="{ 'operate-location__cursor': locationUrl }"
      ref="operateLocation"
      @click="handleOperateLocation($event)"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'operate-location',
  props: {
    operateLocationModule: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    locationImg() {
      if (this.operateLocationModule && this.operateLocationModule.info && this.operateLocationModule.info.imgUrl) {
        return this.operateLocationModule.info.imgUrl || ''
      }
      return ''
    },
    locationUrl() {
      if (this.operateLocationModule && this.operateLocationModule.url) {
        return this.operateLocationModule.url || ''
      }
      return ''
    }
  },
  methods: {
    handleOperateLocation(event) {
      if (!this.locationUrl) return
      if (/^xeswangxiao/.test(this.locationUrl)) return

      window.open(this.locationUrl)

      const XESLog = new this.$XESLog({
        key: 'xeslog-click-operateLocation',
        imageurl: this.locationImg,
        url: this.locationUrl
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    }
  }
}
</script>

<style scoped lang="scss">
.operate-location {
  width: 360px;
  min-height: 88px;
}
.operate-location__image {
  display: inline-block;
  width: 360px;
  min-height: 88px;
  background-size: contain;
  background-repeat: no-repeat;
}
.operate-location__cursor {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/OperateLocation.vue